module.exports = __webpack_public_path__ + "static/media/UnitedSansReg-Light.be14857f.woff";